import React, { useContext } from "react";

import { ThemeContext } from "../../globalStyles";
import { THEME } from "../../globalStyles/types";
import Switcher from "./switcher/Switcher";

// Sun (light) on the right of the track, moon (dark) on the left — same mapping
// as CRM's components/themeSwitcher/ThemeSwitcher.tsx.
const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return <Switcher onToggle={toggleTheme} defaultValue={theme === THEME.light} />;
};

export default ThemeSwitcher;
